var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGoogleChat = function SvgGoogleChat(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_19068",
    transform: "translate(0 -0.0210084) scale(0.00840336)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_19068",
    width: 119,
    height: 124,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHcAAAB8CAMAAABkIN97AAAAe1BMVEUArEf///9buXQAgy1nvn0AqkAAgSlFp18NhDEUpkjY7t4Mr0tjv3wEgS0ApzUAqDpOtWpWuHC338H1+vZ+xpDf8OPq9u6/4ceSz6JwwYWr2Lal1bF4w4uGypdTsmyb06jI59Anr05EtF8jj0A5m1EPlT0MjDYDojwqsleIupXSAAAB8UlEQVRoge3b23KCMBCA4Q0YPENCULRqRXt8/ycstZ1Oq2HjJGzoxf4P4DebzQXiCMKRqTfbUW9tN7W5fCw42AeldNJjWqmd2zWV6hP9Su2Ny6Vg25n3DndHwrYT71DX9LrZP7DB3JJo3NYtMbcim1cfMJeMTZIR5pIdcxu77LLLLrvssjucO6vL6+qxb4+L+1xzhMJS5t3y+R63OeVgab5Mvcsmj063LKSNDXLTLBs73FlhVQPdNnRiEGf7tMFu9oTdLmisu+1j3gwbGA5d44a72KWGcxcb7mIHDXMyN00xt7tgd8kuu+yyyy677LLLLrvssssuu//DXSAuvJK5usLcl8CBEXeHuVMyV60wdx540J2urgTmAkxIXJ0YhzsNgjtcnayEw4Xpa8iOba5W1Vo43U85nXi2XOjrklHVXN6zO12Yw9Szt/XqJvP9ft/t+pcjv12wyy677LLLLrvs9tH7MG5xGMbNm0HcIkFYOlee1kO4EmYYS+TKXK9QFnWlb6BqXEXdopn59fNlxMeVOXovQutkwbEgGleeaNkOl5y1u/Ss1ZWSnLW6tDe5y5UyAnvrRtitzY3EXruxWDEQe+UWMa7UjSvjsb9dCfHYX2683V5cLYdgBZT5EKwAsc3biYvI7Of/6Zrt+/l4xyNRr30AKOZ1CyPFDbsAAAAASUVORK5CYII="
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "google-chat.6f58e42a4c540d9e33cc8fd6114c1eb0.svg";